import { tracingAxios } from '../Sentry.js'
import { Environment } from '../../environment.js'

/** A flat stats row (one order or one project) from the admin JSON feeds. */
export type StatRow = Record<string, unknown>

export const fetchOrderStats = async (excludeInternal: boolean): Promise<StatRow[]> => {
  const { data } = await tracingAxios.get<StatRow[]>(`${Environment.API_URL}/admin/stats/orders.json`, {
    params: { excludeInternal },
    withCredentials: true
  })
  return data
}

export const fetchProjectStats = async (excludeInternal: boolean): Promise<StatRow[]> => {
  const { data } = await tracingAxios.get<StatRow[]>(`${Environment.API_URL}/admin/stats/projects.json`, {
    params: { excludeInternal },
    withCredentials: true
  })
  return data
}
